
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.108 46.54h44.793a1 1 0 001-.996V14.562c0-.04-.02-.07-.02-.11-.01-.069-.02-.129-.04-.198-.02-.07-.05-.12-.08-.18-.02-.03-.02-.07-.05-.1-.02-.02-.04-.03-.06-.049-.04-.05-.1-.09-.15-.14-.05-.04-.1-.08-.15-.099-.05-.03-.11-.04-.17-.06-.07-.02-.13-.04-.21-.04-.02 0-.05-.01-.07-.01H7.108c-.03 0-.05.01-.07.01-.07.01-.13.02-.2.04-.06.02-.12.03-.17.06-.05.03-.1.06-.15.1a.67.67 0 00-.15.139c-.02.02-.04.03-.06.05-.02.03-.03.07-.05.1-.03.06-.06.119-.08.179-.02.07-.03.129-.04.199 0 .04-.02.07-.02.11v30.981c-.01.548.44.996.99.996zm41.734-30.982L29.495 29.685 10.148 15.558h38.694zm-40.734.965l20.807 15.193c.18.13.38.189.59.189.21 0 .42-.06.59-.19L50.9 16.524V44.55H8.108V16.523z"}})])
          )
        }
      }
    